import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-customer-notification',
  templateUrl: './online-customer-notification.component.html',
  styleUrls: ['./online-customer-notification.component.scss']
})
export class OnlineCustomerNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
